import React, { Component } from "react";

// SCSS
import "./ShoveberryLevelGrid.scss";

// Icons & Images
import WallTileBackground from "static/assets/shoveberry/images/wall-tile-background.png";
import CrossIcon from "static/assets/shoveberry/images/cross-obstacle.svg";
import BlockToMoveBackground from "static/assets/shoveberry/images/block-to-move-background.png";
import BlockToMoveOtherBlocksBackground from "static/assets/shoveberry/images/block-to-move-other-blocks-background.png";

// Constants
import { SHOVEBERRY_LEVELS_DATA } from "utils/constants";
import { sendResult } from "utils/helper";

// Helper Functions
import { isCoinsOver, isSafeBerry } from "utils/helperFunctions";

class ShoveberryLevelGrid extends Component {
  state = {
    isMobileView: false,
    board: [],
    computedBoard: [],
    currentPlayerPosition: { x: 0, y: 0 },
    movesStack: [],
    timeForFirstMove: 0,
    optimalNoOfMoves: 0,
    totalMoves: 0,
    averageTimeForMove: 0,
    noOfUndo: 0,
    timeAfterLastReset: 0,
    movesAfterLastReset: 0,
    noOfResets: 0,
    timer: 0,
    // currentTime: "",
    // totalTime: "",
    // timeBetweenMove: [],
    // currTime: "",
    // timeToReset: [],
  };

  startCounting() {
    setInterval(this.countUp, 1000);
  }

  countUp = () => {
    this.setState(({ timer, timeAfterLastReset }) => ({
      timer: timer + 1,
      timeAfterLastReset: timeAfterLastReset + 1,
    }));
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.currentLevel !== nextProps.currentLevel) {
      let newArr = [];

      SHOVEBERRY_LEVELS_DATA[nextProps.currentLevel].board.forEach(
        (row, rowIndex) => {
          let arr = [];
          row.forEach((column, columnIndex) => {
            arr.push(column);
          });
          newArr.push(arr);
        }
      );

      this.setState({
        board: newArr,
        computedBoard: JSON.parse(JSON.stringify(newArr)),
        movesStack: [],
        currentPlayerPosition: {
          x: SHOVEBERRY_LEVELS_DATA[nextProps.currentLevel].playerMove.idx,
          y: SHOVEBERRY_LEVELS_DATA[nextProps.currentLevel].playerMove.idy,
        },
      });
    }
    return true;
  }

  componentDidMount() {
    if (window && window.innerWidth < 1023) {
      this.setState({
        isMobileView: true,
      });
    }

    let _self = this;

    document.onkeydown = function (e) {
      _self.keyPressEventHandler(e, _self);
    };

    let newArr = [];

    SHOVEBERRY_LEVELS_DATA[this.props.currentLevel].board.forEach(
      (row, rowIndex) => {
        let arr = [];
        row.forEach((column, columnIndex) => {
          arr.push(column);
        });
        newArr.push(arr);
      }
    );
    this.startCounting();

    this.setState({
      board: newArr,
      computedBoard: JSON.parse(JSON.stringify(newArr)),
      currentPlayerPosition: {
        x: SHOVEBERRY_LEVELS_DATA[this.props.currentLevel].playerMove.idx,
        y: SHOVEBERRY_LEVELS_DATA[this.props.currentLevel].playerMove.idy,
      },
    });
  }

  keyPressEventHandler(e, _self = this) {
    const { currentPlayerPosition } = _self.state;
    let nextPlayerPosition = {};
    let moveAction = "";
    switch (parseInt(e.keyCode)) {
      case 38:
        // Up Arrow
        moveAction = "UP";
        break;

      case 40:
        // Down Arrow
        moveAction = "DOWN";
        break;

      case 37:
        // Left Arrow
        moveAction = "LEFT";
        break;

      case 39:
        // Right Arrow
        moveAction = "RIGHT";
        break;

      default:
        break;
    }

    nextPlayerPosition = _self.getNextPosition(
      moveAction,
      currentPlayerPosition,
      _self
    );

    if (_self.isMoveValid(moveAction, nextPlayerPosition, _self)) {
      let playerPosition = currentPlayerPosition;
      _self.setState(
        {
          totalMoves: _self.state.totalMoves + 1,
          movesAfterLastReset: _self.state.movesAfterLastReset + 1,
          timeForFirstMove:
            _self.state.totalMoves === 0
              ? _self.state.timer
              : _self.state.timeForFirstMove,
          currentPlayerPosition: {
            x: nextPlayerPosition.x,
            y: nextPlayerPosition.y,
          },
        },
        () => {
          localStorage.setItem("moves", _self.state.totalMoves);
          localStorage.setItem("firstMove", _self.state.timeForFirstMove);
          _self.movePlayerToTheNextPosition(
            moveAction,
            nextPlayerPosition,
            playerPosition,
            _self
          );
        }
      );
      // console.log(nextPlayerPosition)
    } else {
      // TODO: Play wrong move sound
      // console.log('invalid move')
    }
  }

  getNextPosition = (action, currentPosition, _self = this) => {
    let nextPosition = {};
    switch (action) {
      case "UP":
        nextPosition["x"] = currentPosition.x - 1;
        nextPosition["y"] = currentPosition.y;
        break;

      case "DOWN":
        nextPosition["x"] = currentPosition.x + 1;
        nextPosition["y"] = currentPosition.y;
        break;

      case "LEFT":
        nextPosition["x"] = currentPosition.x;
        nextPosition["y"] = currentPosition.y - 1;
        break;

      case "RIGHT":
        nextPosition["x"] = currentPosition.x;
        nextPosition["y"] = currentPosition.y + 1;
        break;

      default:
        break;
    }

    return nextPosition;
  };

  isMoveValid(moveAction, nextPlayerPosition, _self) {
    if (
      nextPlayerPosition.x < _self.state.computedBoard.length &&
      nextPlayerPosition.y < _self.state.computedBoard[0].length
    ) {
      let itemOnNextPlayerPosition =
        _self.state.computedBoard[nextPlayerPosition.x][nextPlayerPosition.y];

      if (
        SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].berries.includes(
          itemOnNextPlayerPosition
        )
      ) {
        let positionOfItemNextToTheBerry = _self.getNextPosition(
          moveAction,
          nextPlayerPosition,
          _self
        );
        let itemNextToTheBerry =
          _self.state.computedBoard[positionOfItemNextToTheBerry.x][
            positionOfItemNextToTheBerry.y
          ];
        if (
          SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].berries.includes(
            itemNextToTheBerry
          ) ||
          itemNextToTheBerry === "n" ||
          itemNextToTheBerry === "o" ||
          itemNextToTheBerry === "s"
        ) {
          return false;
        } else {
          return true;
        }
      } else if (
        itemOnNextPlayerPosition !== "n" &&
        itemOnNextPlayerPosition !== "o" &&
        itemOnNextPlayerPosition !== "s"
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  movePlayerToTheNextPosition(
    moveAction,
    nextPlayerPosition,
    currentPlayerPosition,
    _self
  ) {
    // debugger
    let playerDiv = document.querySelector(
      ".shoveberry-level-grid-component__wrapper-player--img"
    );
    let itemOnNextPlayerPosition =
      _self.state.computedBoard[nextPlayerPosition.x][nextPlayerPosition.y];
    let arr = this.state.computedBoard;

    if (
      SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].berries.includes(
        itemOnNextPlayerPosition
      )
    ) {
      // let berryDiv = document.querySelector(`#${itemOnNextPlayerPosition}`);
      // berryDiv.style.transform = `translate(${
      //   _self.getTranslateValues(moveAction, berryDiv, _self).x
      //   }px, ${_self.getTranslateValues(moveAction, berryDiv, _self).y}px)`;

      // Add move to the MovesStack
      let moveStackCopy = _self.state.movesStack;
      moveStackCopy.push({
        element: itemOnNextPlayerPosition,
        action: moveAction,
      });
      _self.setState({
        movesStack: [...moveStackCopy],
      });

      // Change the computed board
      let berryPositionInComputedBoard = _self.getItemPositionInMatrix(
        itemOnNextPlayerPosition,
        _self.state.computedBoard
      );
      // console.log(berryPositionInComputedBoard)
      if (berryPositionInComputedBoard) {
        let elementAtBerryPositionInOriginalBoard =
          _self.state.board[berryPositionInComputedBoard[0]][
            berryPositionInComputedBoard[1]
          ];
        let nextPositionForBerry = _self.getNextPosition(
          moveAction,
          nextPlayerPosition,
          _self
        );

        arr[nextPositionForBerry.x][
          nextPositionForBerry.y
        ] = itemOnNextPlayerPosition;
        if (
          SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].coins.includes(
            elementAtBerryPositionInOriginalBoard
          )
        ) {
          arr[nextPlayerPosition.x][
            nextPlayerPosition.y
          ] = elementAtBerryPositionInOriginalBoard;
        } else {
          arr[nextPlayerPosition.x][nextPlayerPosition.y] = "g";
        }
      }
    }
    // playerDiv.style.transform = `translate(${
    //   _self.getTranslateValues(moveAction, playerDiv, _self).x
    //   }px, ${_self.getTranslateValues(moveAction, playerDiv, _self).y}px)`;

    // Add move to the MovesStack
    let moveStackCopy = _self.state.movesStack;
    moveStackCopy.push({
      element: "p",
      action: moveAction,
    });
    _self.setState({
      movesStack: [...moveStackCopy],
    });

    // Change the computed board
    let elementAtCurrentPlayerPositionInOriginalBoard =
      _self.state.board[currentPlayerPosition.x][currentPlayerPosition.y];
    arr[nextPlayerPosition.x][nextPlayerPosition.y] = "p";
    // console.log(elementAtCurrentPlayerPositionInOriginalBoard)
    if (
      SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].coins.includes(
        elementAtCurrentPlayerPositionInOriginalBoard
      )
    ) {
      arr[currentPlayerPosition.x][
        currentPlayerPosition.y
      ] = elementAtCurrentPlayerPositionInOriginalBoard;
    } else {
      arr[currentPlayerPosition.x][currentPlayerPosition.y] = "g";
    }
    // console.log(arr)
    _self.setState(
      {
        computedBoard: [...arr],
      },
      () => {
        _self.checkForWin(_self);
      }
    );
  }

  checkForWin(_self) {
    let flag = true;
    _self.state.computedBoard.forEach((row, rowIndex) => {
      row.forEach((column, columnIndex) => {
        if (
          SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].berries.includes(
            column
          )
        ) {
          if (
            !SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].coins.includes(
              _self.state.board[rowIndex][columnIndex]
            )
          ) {
            flag = false;
          }
        }
      });
    });
    if (flag) {
      if (_self.props.currentLevel >= 1) {
        const finalObj = {
          gameData: {
            levelData: [
              {
                level: _self.props.currentLevel,
                totalMoves: _self.state.totalMoves,
                timeForFirstMove: _self.state.timeForFirstMove,
                optimalMoves:
                  SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].optimalMoves,
                averageTimeForMove: (
                  _self.state.totalMoves / _self.state.timer
                ).toFixed(2),
                totalTime: _self.state.timer,
                noOfUndo: _self.state.noOfUndo,
                noOfResets: _self.state.noOfResets,
                timeAfterLastReset: _self.state.timeAfterLastReset,
                movesAfterLastReset: _self.state.movesAfterLastReset,
                isLevelCleared: true,
              },
            ],
          },
        };
        console.log(finalObj);
        _self.setState({
          totalMoves: 0,
          timeForFirstMove: 0,
          averageTimeForMove: 0,
          noOfUndo: 0,
          noOfResets: 0,
          timer: 0,
        });
        localStorage.setItem("moves", 0);
        localStorage.setItem("undos", 0);
        localStorage.setItem("reset", 0);
        sendResult(finalObj);
      }
      _self.props.onLevelComplete();
    }
  }

  getItemPositionInMatrix(item, matrix) {
    let position = null;
    matrix.forEach((row, rowIndex) => {
      row.forEach((column, columnIndex) => {
        if (column === item) {
          position = [rowIndex, columnIndex];
        }
      });
    });
    return position;
  }

  getTranslateValues(action, element, _self) {
    let elementX = _self.getComputedTranslateXY(element)[0];
    let elementY = _self.getComputedTranslateXY(element)[1];
    let x = 0;
    let y = 0;
    let translateByValue = document.querySelector(
      ".shoveberry-level-grid-component__block"
    ).clientWidth;

    if (isNaN(elementX)) {
      elementX = 0;
    }
    if (isNaN(elementY)) {
      elementY = 0;
    }

    switch (action) {
      case "UP":
        y = elementY - translateByValue;
        x = elementX;
        break;
      case "DOWN":
        y = elementY + translateByValue;
        x = elementX;
        break;
      case "RIGHT":
        y = elementY;
        x = elementX + translateByValue;
        break;
      case "LEFT":
        y = elementY;
        x = elementX - translateByValue;
        break;

      default:
        break;
    }
    return { x, y };
  }

  getComputedTranslateXY(obj) {
    const transArr = [];
    if (!window.getComputedStyle) return;
    const style = getComputedStyle(obj),
      transform =
        style.transform || style.webkitTransform || style.mozTransform;
    let mat = transform.match(/^matrix3d\((.+)\)$/);
    if (mat) return parseFloat(mat[1].split(", ")[13]);
    mat = transform.match(/^matrix\((.+)\)$/);
    mat ? transArr.push(parseFloat(mat[1].split(", ")[4])) : transArr.push(0);
    mat ? transArr.push(parseFloat(mat[1].split(", ")[5])) : transArr.push(0);
    return transArr;
  }

  getBlockDimensions() {
    let obj = {};
    if (this.state.isMobileView) {
      let width =
        window.innerWidth /
        SHOVEBERRY_LEVELS_DATA[this.props.currentLevel].board[0].length;
      obj = {
        height: width + "px",
        width: width + "px",
      };
    }
    return obj;
  }

  getBlock(key, index) {
    switch (key) {
      case "o":
        return (
          <div
            className="shoveberry-level-grid-component__block"
            style={this.getBlockDimensions()}
            key={Math.random(index)}
          >
            <img
              src={WallTileBackground}
              alt=""
              className="shoveberry-level-grid-component__red-block"
            />
          </div>
        );
      case "s":
        return (
          <div
            className="shoveberry-level-grid-component__block"
            style={this.getBlockDimensions()}
            key={Math.random(index)}
          >
            <img
              src={WallTileBackground}
              alt=""
              className="shoveberry-level-grid-component__yellow-block"
            />
          </div>
        );
      case "b1":
      case "b2":
      case "b3":
      case "b4":
      case "b5":
      case "b6":
        return (
          <div
            className="shoveberry-level-grid-component__wrapper-berry"
            style={this.getBlockDimensions()}
            key={Math.random(index)}
          >
            <img
              id={key}
              src={BlockToMoveBackground}
              alt="berry-block "
              className="shoveberry-level-grid-component__wrapper-berry--img"
            />
          </div>
        );
      case "p":
        return (
          <div
            className="shoveberry-level-grid-component__wrapper-player"
            style={{
              // transform: `translate(${this.state.playerMove.x}px, ${this.state.playerMove.y}px)`,
              ...this.getBlockDimensions(),
            }}
            key={Math.random(index)}
          >
            <img
              src={BlockToMoveOtherBlocksBackground}
              alt="berry-block"
              className="shoveberry-level-grid-component__wrapper-player--img"
            />
          </div>
        );
      case "n":
        return (
          <div
            className="shoveberry-level-grid-component__block shoveberry-level-grid-component__empty-block"
            style={this.getBlockDimensions()}
            key={Math.random(index)}
          />
        );
      case "g":
        return (
          <div
            className="shoveberry-level-grid-component__block shoveberry-level-grid-component__green"
            style={this.getBlockDimensions()}
            key={Math.random(index)}
          />
        );
      case "c1":
      case "c2":
      case "c3":
      case "c4":
      case "c5":
      case "c6":
        return (
          <div
            id={key}
            className="shoveberry-level-grid-component__wrapper-coin"
            style={this.getBlockDimensions()}
            key={Math.random(index)}
          >
            <img src={CrossIcon} alt="" />
          </div>
        );
      default:
    }
  }

  getColumnNumber() {
    let numberOfColumns = SHOVEBERRY_LEVELS_DATA[this.props.currentLevel]
      .board[0]
      ? SHOVEBERRY_LEVELS_DATA[this.props.currentLevel].board[0].length
      : 1;
    let str = "";
    for (let i = 0; i < numberOfColumns; i++) {
      str += "auto ";
    }
    return str;
  }

  undoHandler() {
    if (this.state.movesStack.length > 0) {
      let moveStackCopy = this.state.movesStack;
      let lastMove = moveStackCopy.pop();
      this.setState(
        {
          movesStack: JSON.parse(JSON.stringify(moveStackCopy)),
        },
        () => {
          this.moveElement(
            lastMove.element,
            this.getReverseAction(lastMove.action)
          );

          // Checking if the berry was moved with the player.
          if (lastMove.element === "p" && moveStackCopy.length > 1) {
            let secondLastMove = moveStackCopy.pop();
            if (
              SHOVEBERRY_LEVELS_DATA[this.props.currentLevel].berries.includes(
                secondLastMove.element
              )
            ) {
              this.setState(
                {
                  noOfUndo: this.state.noOfUndo + 1,
                  movesStack: JSON.parse(JSON.stringify(moveStackCopy)),
                },
                () => {
                  localStorage.setItem("undos", this.state.noOfUndo);
                  this.moveElement(
                    secondLastMove.element,
                    this.getReverseAction(secondLastMove.action)
                  );
                }
              );
            }
          }
        }
      );
    }
  }

  getReverseAction = (action) => {
    let reverseAction = "";
    switch (action) {
      case "UP":
        reverseAction = "DOWN";
        break;
      case "DOWN":
        reverseAction = "UP";
        break;
      case "LEFT":
        reverseAction = "RIGHT";
        break;
      case "RIGHT":
        reverseAction = "LEFT";
        break;
      default:
        break;
    }
    return reverseAction;
  };

  moveElement = (element, action) => {
    let elementPositionInComputedBoard = this.getItemPositionInMatrix(
      element,
      this.state.computedBoard
    );
    let nextPositionForElement = this.getNextPosition(action, {
      x: elementPositionInComputedBoard[0],
      y: elementPositionInComputedBoard[1],
    });
    let computedBoardCopy = JSON.parse(
      JSON.stringify(this.state.computedBoard)
    );

    if (
      SHOVEBERRY_LEVELS_DATA[this.props.currentLevel].coins.includes(
        this.state.board[elementPositionInComputedBoard[0]][
          elementPositionInComputedBoard[1]
        ]
      )
    ) {
      computedBoardCopy[elementPositionInComputedBoard[0]][
        elementPositionInComputedBoard[1]
      ] = this.state.board[elementPositionInComputedBoard[0]][
        elementPositionInComputedBoard[1]
      ];
    } else {
      computedBoardCopy[elementPositionInComputedBoard[0]][
        elementPositionInComputedBoard[1]
      ] = "g";
    }
    computedBoardCopy[nextPositionForElement.x][
      nextPositionForElement.y
    ] = element;
    this.setState({
      computedBoard: JSON.parse(JSON.stringify(computedBoardCopy)),
    });

    if (element === "p") {
      this.setState({
        currentPlayerPosition: { ...nextPositionForElement },
      });
    }
  };

  reset() {
    let _self = this;
    // let interval = setInterval(function async() {
    if (_self.state.movesStack.length > 0) {
      // let moveStackCopy = JSON.parse(JSON.stringify(_self.state.movesStack))
      // let lastMove = moveStackCopy.pop();
      // _self.setState(
      //   {
      //     movesStack: moveStackCopy,
      //   },
      //   () => {
      //     _self.moveElement(
      //       lastMove.element,
      //       _self.getReverseAction(lastMove.action)
      //     );
      //   }
      _self.setState(
        {
          movesStack: [],
          noOfResets: _self.state.noOfResets + 1,
          timeAfterLastReset: 0,
          movesAfterLastReset: 0,
          computedBoard: JSON.parse(JSON.stringify(_self.state.board)),
          currentPlayerPosition: {
            x: SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].playerMove.idx,
            y: SHOVEBERRY_LEVELS_DATA[_self.props.currentLevel].playerMove.idy,
          },
        },
        () => {
          localStorage.setItem("reset", _self.state.noOfResets);
        }
      );
    }
    //  else {
    //   clearInterval(interval);
    // }
    // }, 150);
  }

  render() {
    const { onLevelComplete, playerMove, currentLevel = 0 } = this.props;

    const { computedBoard, board } = this.state;

    return (
      <div className="shoveberry-level-grid-component">
        <div
          className="shoveberry-level-grid-component__main-container"
          style={{ gridTemplateColumns: this.getColumnNumber() }}
        >
          {computedBoard.map((item, index) => {
            return item.map((key, idx) => {
              return this.getBlock(key, index * idx);
            });
          })}
        </div>
      </div>
    );
  }
}
export default ShoveberryLevelGrid;
